import request from '@/utils/request'
// 获取标签列表
export function tags_list(params) {
	return request({
		url: '/discover/tag/page',
		method: 'get',
		params: params,
	})
}

// 修改标签
export function update_tag(params) {
	return request({
		url: '/discover/tag/update',
		method: 'post',
		data: params,
	})
}